// 导出记录接口
import request from '@/utils/request'
import { tansParams } from '@/utils'

// 分页查询导出记录
export const exportRecordPager = params => {
	return request({
		url: process.env.VUE_APP_BASE_API + 'appServer/api/exportRecord/exportRecordPager',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 导出记录中已导出的报告重新下载
export const exportFileRecordRenewlDonwload = params => {
	return (
		process.env.VUE_APP_BASE_API +
		process.env.VUE_APP_PREFIX_API_APPSERVER +
		'/api/fileRecord/downloadReportFile?' +
		tansParams(params)
	)
}
